// resources/js/product-list.js
import axios from "axios";

const MOBILE_BREAKPOINT = 968;
const DATA_ATTR = 'data-product-list';

// Карта JS‑ключей → GET‑параметров
const API_PARAM_MAP = {
    skinTypes:   'skin_types',
    skinNeeds:   'skin_needs',
    ingredients: 'ingredients',
    productType: 'product_type',
    promotions:  'promotions',
};

export function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
}

const container = document.querySelector(`[${DATA_ATTR}]`);
if (container) initProductList(container);

function initProductList(container) {
    const template        = document.querySelector(`[${DATA_ATTR}-product-cart-template]`);
    const templateReward  = document.querySelector(`[${DATA_ATTR}-reward-template]`);
    const loader          = container.querySelector(`[${DATA_ATTR}-loader]`);
    const list            = container.querySelector(`[${DATA_ATTR}-list]`);
    const loadMoreBtn     = container.querySelector(`[${DATA_ATTR}-show-more]`);

    let page      = 1;
    const perPage = 12;
    let hasMore   = true;
    let isLoading = false;

    const filters = {
        skinTypes:   ['all'],
        skinNeeds:   ['all'],
        ingredients: ['all'],
        productType: ['all'],
        promotions:  ['all'],
    };
    const tempFilters = {};

    // 1) Настраиваем фильтры и «клик вне»
    setupFilters(container);
    document.addEventListener('click', e => {
        if (!e.target.closest(`[${DATA_ATTR}-filter]`)) {
            closeOpenLists();
        }
    });

    // 2) Считываем параметры из URL, синхронизируем UI:
    applyInitialFiltersFromURL();
    container.querySelectorAll(`[${DATA_ATTR}-filter]`)
        .forEach(el => {
            const key = el.dataset.productListFilter;
            syncOptionUI(el, filters[key]);
            updateFilterTitle(el);
        });

    // 3) Первый запрос
    resetAndFetch();
    loadMoreBtn.addEventListener('click', fetchAndRender);

    // --- чтение URL-параметров в filters ---
    function applyInitialFiltersFromURL() {
        const params = new URLSearchParams(window.location.search);
        Object.entries(API_PARAM_MAP).forEach(([jsKey, urlKey]) => {
            if (!params.has(urlKey)) return;
            const vals = params.get(urlKey)
                .split(',')
                .map(v => v.trim())
                .filter(Boolean);
            if (vals.length) filters[jsKey] = vals;
        });
    }

    // --- получение и рендеринг ---
    async function fetchAndRender() {
        if (isLoading || !hasMore) return;
        isLoading = true;
        loader.style.display = 'flex';

        try {
            const { products, hasMore: more } = await fetchProducts(page, perPage, filters);
            products.forEach(renderProduct);
            hasMore = more;
            page++;
            loadMoreBtn.style.display = hasMore ? 'flex' : 'none';
        } catch (err) {
            console.error(err);
        } finally {
            loader.style.display = 'none';
            isLoading = false;
        }
    }

    async function fetchProducts(page, perPage, filters) {
        const params = { page, per_page: perPage };
        Object.entries(filters).forEach(([jsKey, arr]) => {
            const apiKey = API_PARAM_MAP[jsKey];
            if (arr.length && !arr.includes('all')) {
                params[apiKey] = arr.join(',');
            }
        });
        const qs = new URLSearchParams(params).toString();
        const url = `/api/products?${qs}`;
        const { data } = await axios.get(url);
        return { products: data.data || [], hasMore: data.has_more };
    }

    function renderProduct(product) {
        const clone    = document.importNode(template.content, true);
        const card     = clone.querySelector(`[${DATA_ATTR}-card]`);
        const imgMain  = clone.querySelector(`[${DATA_ATTR}-image-main]`);
        const imgHover = clone.querySelector(`[${DATA_ATTR}-image-hover]`);
        const label    = clone.querySelector(`[${DATA_ATTR}-label]`);
        const nameEl   = clone.querySelector(`[${DATA_ATTR}-name]`);
        const desc     = clone.querySelector(`[${DATA_ATTR}-desc]`);
        const btn      = clone.querySelector(`[${DATA_ATTR}-button]`);
        const rewards  = clone.querySelector(`[${DATA_ATTR}-rewards]`);

        card.href = `/product/${product.id}`;
        btn.addEventListener('click', () => window.location.href = card.href);

        if (product.rewards?.length) {
            product.rewards.forEach(r => {
                const rc = document.importNode(templateReward.content, true);
                rc.querySelector('img').src = r.image;
                rewards.appendChild(rc);
            });
        }

        if (product.first_image)  imgMain.src = product.first_image;
        if (product.second_image) imgHover.src = product.second_image;
        if (product.product_type) label.textContent = product.product_type.name;
        else                       label.style.display = 'none';

        nameEl.textContent = product.name;
        desc.textContent   = product.description;

        list.appendChild(clone);
        requestAnimationFrame(() => card.classList.add('show'));
    }

    // --- UI фильтров ---
    function setupFilters(container) {
        container.querySelectorAll(`[${DATA_ATTR}-filter]`)
            .forEach(el => bindFilter(el));
    }

    function bindFilter(el) {
        const type = el.dataset.productListFilterType;
        const key  = el.dataset.productListFilter;
        const hdr  = el.querySelector(`[${DATA_ATTR}-header]`);

        hdr.addEventListener('click', e => {
            e.stopPropagation();
            type === 'single' ? toggleSingle(el, key) : toggleList(el, key);
        });

        if (type === 'list') setupListControls(el, key);
        else if (type === 'list-single') setupListSingleControls(el, key);
    }

    function toggleSingle(el, key) {
        const act = el.classList.toggle('active');
        filters[key] = act ? ['active'] : ['all'];
        updateFilterTitle(el);
        resetAndFetch();
    }

    function toggleList(el, key) {
        const isOpen = el.classList.toggle('open');
        if (isOpen) {
            tempFilters[key] = [...filters[key]];
            // закрыть другие выпадашки
            container.querySelectorAll(`[${DATA_ATTR}-filter].open`)
                .forEach(o => o !== el && o.classList.remove('open'));
        }
        else if (!isMobile()) {
            applyTemp(el, key);
        }
    }

    function setupListSingleControls(el, key) {
        el.querySelectorAll(`[${DATA_ATTR}-filter-option]`).forEach(opt => {
            opt.addEventListener('click', e => {
                e.stopPropagation();
                const v = opt.dataset.productListFilterOption;
                tempFilters[key] = v === 'all' ? ['all'] : [v];
                syncOptionUI(el, tempFilters[key]);
                applyTemp(el, key);
            });
        });
        el.querySelector(`[${DATA_ATTR}-filter-close]`)
            .addEventListener('click', e => { e.stopPropagation(); el.classList.remove('open'); });
    }

    function setupListControls(el, key) {
        el.querySelectorAll(`[${DATA_ATTR}-filter-option]`).forEach(opt => {
            opt.addEventListener('click', e => {
                e.stopPropagation();
                updateTempList(key, opt.dataset.productListFilterOption);
                syncOptionUI(el, tempFilters[key]);

                if (!isMobile()) {
                    filters[key] = [...tempFilters[key]];
                    updateFilterTitle(el);
                    resetAndFetch();
                    // Фильтр остаётся открытым
                }
            });
        });

        el.querySelector(`[${DATA_ATTR}-filter-reset]`)
            .addEventListener('click', e => {
                e.stopPropagation();
                tempFilters[key] = ['all'];
                syncOptionUI(el, ['all']);
                if (!isMobile()) applyTemp(el, key);
            });

        el.querySelector(`[${DATA_ATTR}-filter-accept]`)
            .addEventListener('click', e => {
                e.stopPropagation();
                applyTemp(el, key);
            });

        el.querySelector(`[${DATA_ATTR}-filter-close]`)
            .addEventListener('click', e => {
                e.stopPropagation();
                el.classList.remove('open');
            });
    }

    function updateTempList(key, val) {
        const arr = tempFilters[key] = tempFilters[key] || [];
        if (val === 'all') arr.splice(0, arr.length, 'all');
        else {
            const iAll = arr.indexOf('all');
            if (iAll > -1) arr.splice(iAll, 1);
            const idx = arr.indexOf(val);
            idx > -1 ? arr.splice(idx, 1) : arr.push(val);
            if (!arr.length) arr.push('all');
        }
    }

    function applyTemp(el, key) {
        el.classList.remove('open');
        filters[key] = [...tempFilters[key]];
        // обновить UI
        syncOptionUI(el, filters[key]);
        updateFilterTitle(el);
        resetAndFetch();
    }

    function closeOpenLists() {
        let applied = false;
        container.querySelectorAll(`[${DATA_ATTR}-filter].open`)
            .forEach(el => {
                const type = el.dataset.productListFilterType;
                const key  = el.dataset.productListFilter;
                if (type === 'list' && !isMobile()) {
                    applyTemp(el, key);
                    applied = true;
                } else {
                    el.classList.remove('open');
                }
            });
        if (applied) resetAndFetch();
    }

    function syncOptionUI(el, values) {
        el.querySelectorAll(`[${DATA_ATTR}-filter-option]`)
            .forEach(opt => {
                const v = opt.dataset.productListFilterOption;
                opt.classList.toggle('active', values.includes(v));
            });
    }

    function updateFilterTitle(el) {
        const key   = el.dataset.productListFilter;
        const name  = el.dataset.productListFilterName;
        const title = el.querySelector(`[${DATA_ATTR}-title]`);
        const sel   = filters[key];

        if (Array.isArray(sel) && sel.length === 1 && sel[0] !== 'all') {
            const opt = el.querySelector(`[data-product-list-filter-option="${sel[0]}"]`);
            title.textContent = opt?.textContent || name;
        } else {
            title.textContent = name;
        }
    }

    function resetAndFetch() {
        page    = 1;
        hasMore = true;
        list.innerHTML = '';
        fetchAndRender();
    }
}
